import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const ProtectedRoute = ({ element }) => {
  const { isLoggedIn, accessToken, loginTime, expiryTime } = useSelector(
    (state) => state.auth
  );
  const currentTime = Date.now();
  const isTokenValid = accessToken && (expiryTime ? currentTime < expiryTime : true);
  if (!isLoggedIn || !isTokenValid) {
    return <Navigate to="/" replace />;
  }
  return element;
};
export default ProtectedRoute;
